export const STORAGE_KEYS = {
  activeAdminId: 'activeAdminId',
  adminsList: 'adminsList',
  preImpersonationNavState: 'preImpersonationNavState',
  loginSuccessTourCheck: 'login_success_tour_check',
} as const;
